import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { InfoboxService } from '../common/infobox/infobox.service';
import { Permissions } from '@/common/enums/Permissions';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
	private readonly auth = inject(AuthService);
	private readonly infobox = inject(InfoboxService);
	private readonly router = inject(Router);

	canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
		const required: Permissions | Permissions[] = route.data?.['permission'];

		if (!required) {
			return true;
		}

		const permissions = this.auth.permissionsByCode();
		const granted = (Array.isArray(required) ? required : [required]).some((code) => permissions[code]);

		if (granted) {
			return true;
		}

		this.infobox.error('Brak uprawnień do tej sekcji');

		return this.router.createUrlTree(['/login']);
	}
}
